import {Approver} from '@domain/shifthandover'
import {REGULAR_SIZE} from '@hconnect/common/consts'
import {User} from '@hconnect/common/types'
import {Box, Grid, Switch} from '@mui/material'
import {isEqual} from 'lodash'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

import {UserSearchField} from './UserSearchField'

type ApproversFieldProps = {
  plantId: string
  onChange: (approvers: Approver[]) => void
  toggleApprovers: (needsApproval: boolean) => void
  needsApproval?: boolean
  disableNeedsApproval?: boolean
  disableApproversField?: boolean
  errorText?: string
  approvers?: Approver[]
  requiredApprovers?: User[]
}

export const ApproversField: FC<ApproversFieldProps> = ({
  plantId,
  onChange,
  needsApproval,
  toggleApprovers,
  errorText,
  approvers = [],
  requiredApprovers = [],
  disableApproversField,
  disableNeedsApproval
}) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)
  const users = approvers.map(({user}) => user)

  return (
    <Grid container m={0} alignItems="center" spacing={2}>
      <Grid item {...REGULAR_SIZE}>
        <Box pl={2}>
          {t('shiftEvent.action.needsApproval')}{' '}
          <Switch
            checked={!!needsApproval}
            data-test-id="approver-field-toggle"
            onChange={() => toggleApprovers(!needsApproval)}
            color="primary"
            disabled={disableNeedsApproval}
          />
        </Box>
      </Grid>
      {needsApproval ? (
        <Grid item xs={12}>
          <UserSearchField
            plantId={plantId}
            label={t('shiftEvent.action.approvers')}
            errorText={errorText}
            onChange={(newAssignee) => {
              if (newAssignee && !isEqual(newAssignee, users)) {
                onChange(
                  newAssignee.map((newAssignee) => {
                    const existingApprover = approvers.find(({user}) => user.id === newAssignee.id)
                    return existingApprover
                      ? existingApprover
                      : {
                          user: newAssignee,
                          status: 'pending'
                        }
                  })
                )
              } else if (!newAssignee) {
                onChange([])
              }
            }}
            value={users}
            data-test-id="approverSearch"
            disabled={disableApproversField}
            lockedUsers={requiredApprovers}
            sx={{flex: 1}}
          />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <span>{t('shiftEvent.action.needsApprovalToggle')}</span>
        </Grid>
      )}
    </Grid>
  )
}
